<template>
    <v-container>
        <!-- <v-row>
            <v-col cols="8"></v-col>
            <v-col cols="4">
              <v-btn @click="downloadCSV" color="primary">Descargar CSV</v-btn>
            </v-col>
          </v-row> -->
      <v-data-table
        :headers="c_headers"
        :items="formattedRows"
        class="elevation-1"
        disable-pagination
        hide-default-footer
      >
      </v-data-table>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "GenericTableComponent",
    props: {
      data: {
        type: Array,
        required: true,
      },
      headers: {
        type: Array,
        default: () => [],
      },
    },
    computed: {
      c_headers() {
        if (this.headers.length > 0) {
          return this.headers.map(key => ({ text: key, value: key }));
        }
        const allKeys = new Set();
        this.data.forEach(row => {
          Object.keys(row).forEach(key => allKeys.add(key));
        });
        return [...allKeys].map(key => ({ text: key, value: key }));
      },
      formattedRows() {
        return this.data.map(row => {
          const formattedRow = {};
          this.c_headers.forEach(header => {
            formattedRow[header.value] = row[header.value] || "";
          });
          return formattedRow;
        });
      },
    },
    methods: {
      downloadCSV() {
        const separator = ';';
        const headers = this.headers.map(header => header.text).join(separator);
        const rows = this.formattedRows.map(row =>
          this.headers.map(header => `"${(row[header.value] || '').toString().replace(/"/g, '""')}"`).join(separator)
        );
        console.log(rows);
        const csvContent = `data:text/csv;charset=utf-8,${headers}\n${rows.join('\n')}`;
        const encodedUri = encodeURI(csvContent);
        const link = document.createElement("a");
        link.setAttribute("href", encodedUri);
        link.setAttribute("download", "data.csv");
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      },
    },
  };
  </script>
  
  <style scoped>
  /* Add custom styles here if needed */
  </style>
  